import axios from 'axios';

/**
 * This service simply installs the Axios http provider as a read-only property on the Vue prototype., which will then
 * be accessible to all components through the service locator.
 */
export class HttpService {
  static install ({$services}) {
    $services.register('http', axios);
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/HttpService.js